import appConst from '@/const/app.const';
import request from './request';


export default {
  async uploadImage({ image, type, file }) {
    return request.post({
      // action: 'user.account.upload',
      action: 'hitch.image.upload',
      image,
      type,
      file,
    }, {
      apiServer: appConst.HITCH_REGISTER_API,
    }, true).then((v) => v.data);
  },
};
